import InfoNotice from './InfoNotice'
export default InfoNotice
